
import { FormPage } from "../../types/form";

export const page1Config: FormPage = {
  page: 1,
  elements: [
    {
      id: "teacher_id_name",
      type: "teacher_search",
      label: "ค้นหาครู",
      name: "teacher_id_name_display",
      required: true,
      description: "ค้นหาด้วย รหัส หรือ ชื่อครู",
      targetField: "teacher_id" // This will be filled automatically when a teacher is selected
    },
    {
      id: "teacher_id_field",
      type: "text",
      label: "รหัสครู",
      name: "teacher_id",
      required: true,
      readOnly: true, // This field is filled automatically from the teacher search
      description: "รหัสครูจะถูกกรอกโดยอัตโนมัติเมื่อเลือกครูจากช่องด้านบน"
    },
    {
      id: "terms_instruction",
      type: "rich_text_instruction",
      text: `<p><strong>ครูต้องลงพัฒนาการไม่เกิน<u>เวลา 12.00 น. ของวันถัดไป</u></strong> ถ้าครูส่งหลัง 12.00 ของวันถัดไป จะถูกระบุว่า"ส่งช้า"</p>
<br />
<p><strong><u>ยกเว้น</u>คลาสวันที่ 25 จะต้องทำการส่งพัฒนาการภายใน 00.00 น. จึงจะถือว่า "ส่งตรง"</strong></p>
<p>- ส่งภายใน วันที่ 26 เวลา 00.01 - 12.00 น. จะถือว่า <strong>"ส่งช้า"</strong></p>
<p>- ส่ง วันที่ 26 หลัง 12.00 จะถือว่า <strong>"ไม่ส่ง"</strong></p>
<br />
<p><strong>ซึ่งส่วนกลางจะตัดรอบส่งพัฒนาการให้ผู้ปกครองภายใน <u>24 ชั่วโมง</u> หลังครูสอนเสร็จ</strong> ดังนั้นคุณครูจะต้องส่งพัฒนาการของคลาสนั้น ๆ ให้เรียบร้อยก่อนตัดรอบ <strong>หากส่งตามหลังเกิน <u>24 ชั่วโมงหลังสอนเสร็จ</u> จะถือว่าครูไม่ส่งพัฒนาการ และจะไม่ได้รับค่าสอนของคลาสนั้น</strong></p>`
    },
    {
      id: "terms_agreement",
      type: "checkbox",
      label: "กรุณาอ่านเงื่อนไขให้ครบถ้วนก่อนยอมรับเงื่อนไข",
      name: "agreed_to_terms",
      required: true,
      options: [
        { value: true, label: "รับทราบและยอมรับเงื่อนไข" }
      ]
    }
  ]
};
